const GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzv_XTTbTeL0FSd4l8hGlEJTqBspUmDOeKeBqf5qmoTzunIq7hTieSTq24po1O01OiO/exec";

export function saveContactToGoogleSheet(formData: FormData) {
    return fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: formData,
    });
}
